import { NavLink } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy-900 text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">CV Samudera Alam Perkasa</h3>
            <p className="mb-4 text-gray-300">
              Penyedia layanan tenaga kerja profesional dengan komitmen untuk membangun masa depan
              yang lebih cerah melalui solusi tenaga kerja berkualitas.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                className="text-white hover:text-yellow-500 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://instagram.com"
                className="text-white hover:text-yellow-500 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://linkedin.com"
                className="text-white hover:text-yellow-500 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Tautan Cepat</h3>
            <ul className="space-y-2">
              {[
                { name: 'Beranda', path: '/' },
                { name: 'Tentang Kami', path: '/about' },
                { name: 'Layanan', path: '/services' },
                { name: 'Portofolio', path: '/portfolio' },
                { name: 'Tim Kami', path: '/team' },
                { name: 'Kontak', path: '/contact' },
              ].map((item) => (
                <li key={item.name}>
                  <NavLink
                    to={item.path}
                    className="text-gray-300 hover:text-yellow-500 transition-colors"
                  >
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Layanan Kami</h3>
            <ul className="space-y-2">
              <li>
                <a href="/services" className="text-gray-300 hover:text-yellow-500 transition-colors">
                  Rekrutmen Tenaga Kerja
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-yellow-500 transition-colors">
                  Manajemen Tenaga Kerja
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-yellow-500 transition-colors">
                  Pengembangan Keterampilan
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-yellow-500 transition-colors">
                  Pelatihan Profesional
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">Kontak</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin size={20} className="mr-2 text-yellow-500 flex-shrink-0 mt-1" />
                <span>Jl. Juwingan No 94, Gubeng Kertajaya, Surabaya</span>
              </li>
              <li className="flex items-center">
                <Phone size={20} className="mr-2 text-yellow-500 flex-shrink-0" />
                <span>+62 877-1208-1994</span>
              </li>
              <li className="flex items-center">
                <Mail size={20} className="mr-2 text-yellow-500 flex-shrink-0" />
                <span>info@samuderaalam.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} CV Samudera Alam Perkasa. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;